<template>
  <div>
    <mdb-modal size="lg" @shown="componentDidMount" :show="visible" @close="hideModal">
      <mdb-modal-header>
        <mdb-modal-title>Admin Zones</mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body>
          <mdb-row v-if="user!=null">
              <mdb-col col="12" class="d-flex flex-wrap flex-center">
                  <div class="zone-btn" @click="addZone(zone)" :class="{active: checkActiveZone(zone)}" v-for="zone in zones" v-bind:key="zone.id">{{zone.name}}</div>
              </mdb-col>
          </mdb-row>
      </mdb-modal-body>
      <mdb-modal-footer>
        <mdb-spinner v-if="loading" small color="blue"/>
        <mdb-btn v-if="!loading" @click="updateAdminZone" color="success">Update</mdb-btn>
        <mdb-btn color="danger" @click="hideModal">Close</mdb-btn>
      </mdb-modal-footer>
    </mdb-modal>
  </div>
</template>

<script>
  import { mdbModal, mdbModalHeader, mdbModalTitle, mdbModalBody, mdbModalFooter, mdbBtn, mdbSpinner, mdbRow, mdbCol } from 'mdbvue';
  import {ajax} from '../js/ajax';
//   import {getColor} from '../js/colors';
//   import {checkPermissions} from '../js/helper';
// import {validateRequired, validateEmail, validateIC, validatePhone, validatePercentage} from '../js/validation';

  export default {
    components: {
      mdbModal, mdbRow, mdbCol,
      mdbModalHeader, mdbSpinner,
      mdbModalTitle,
      mdbModalBody,
      mdbModalFooter,
      mdbBtn,
    },
    props: ['visible', 'close', 'zones', 'focus_user'],
    data: ()=>({
      loading: false,
      user: null
    }),
    methods: {
        hideModal(){
            this.user=null;
            this.loading=false;
            this.close();
        },
        componentDidMount(){
            this.user={...this.focus_user}
        },
        checkActiveZone(zone){
            var index =this.user.admin_zones.findIndex(element=>{
                return element.id==zone.id;
            });
            if(index>=0){
                return true;
            }
            return false;
        },
        addZone(zone){
            let temp = [...this.user.admin_zones];
            var index =temp.findIndex(element=>{
                return element.id==zone.id;
            });
            if(index>=0){
                temp.splice(index, 1);
            }else{
                temp.push(zone);
            }
            this.user.admin_zones=temp;
        },
        updateAdminZone(){
            if(this.loading){
                return false;
            }
            this.loading=true;
            ajax({
                url: "admin/update_admin_zones",
                data: {
                    id: this.user.id,
                    zones: this.user.admin_zones
                },
                complete: ()=>this.loading=false,
                success: ()=>{
                    this.$notify.success({message: "Admin Zones has been updated.", position:'top right', timeOut: 5000});
                    this.hideModal();
                },
            }, this)
        }
    }
  };
</script>

<style scoped>
.zone-btn{
    padding: 5px 15px 5px 15px;
    border: 1px solid #eee;
    cursor: pointer;
    margin: 5px
}
.zone-btn:hover{
    border-color: #9c27b0;
}
.zone-btn.active{
    border-color: #9c27b0;
    color: #9c27b0;
}
</style>